<template>
  <tr>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ prima.fecha | moment("DD MMMM YYYY") }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ prima.antiguedad }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ prima.semana.semana }} - {{ prima.semana.periodo }}</td>
  </tr>
</template>

<script>
export default {
  name: 'ItemPrimaVacacional',
  props: {
    prima: Object
  }
}
</script>
